import { MdOutlineShoppingCart } from 'react-icons/md';

import ContractSection from './ContractSection';
import { nameAndPriceColumns } from './helper';

const Procurement = ({ services = [] }) => {
  const procurementServices = services.filter((service) => service.serviceType === 'procurement');

  if (!procurementServices.length) return null;

  return (
    <ContractSection
      icon={MdOutlineShoppingCart}
      title="Татан авалтын үйлчилгээ"
      description="Бараа татан авахад ашиглах тээврийн хэрэгслийн төрөл тус бүрийн төлбөр."
      columns={nameAndPriceColumns}
      dataSource={procurementServices}
    />
  );
};

export default Procurement;
